module.exports = __webpack_public_path__ + "static/img/t16.b076c0b9.png";